import { color } from "@funded-here-interface/common";
import { MantineTheme, createStyles } from "@mantine/core";

export const useStyles = createStyles((theme: MantineTheme) => ({
    customTooltip:{
        padding: "15px",
        backgroundColor: "#fff",
        border: "0.5px solid #111"
    }
}))